<template>
  <div class="footer" style="display:none;">
  </div>
</template>

<script setup lang="ts"></script>
